import { TYPE_ORDER, TYPE_COLORS } from './types'

interface FilterControlsProps {
  activeTypes: Set<string>
  counts: Record<string, number>
  onToggle: (type: string) => void
}

export default function FilterControls({
  activeTypes,
  counts,
  onToggle,
}: FilterControlsProps) {
  return (
    <div className="filter-controls">
      <div className="filter-title">Tipos</div>
      {TYPE_ORDER.map((type) => {
        const active = activeTypes.has(type)
        const count = counts[type] || 0
        return (
          <button
            key={type}
            className={`filter-item ${active ? 'active' : 'inactive'}`}
            onClick={() => onToggle(type)}
          >
            <span
              className="type-dot"
              style={{
                background: TYPE_COLORS[type],
                opacity: active ? 1 : 0.3,
              }}
            />
            <span className="filter-label">{type}</span>
            <span className="filter-count">{count}</span>
          </button>
        )
      })}
    </div>
  )
}
